module.exports = {
	"root": "findify-components-autocomplete--product-matches",
	"product-card": "findify-components-autocomplete--product-matches__product-card",
	"productCard": "findify-components-autocomplete--product-matches__product-card",
	"imageWrap": "findify-components-autocomplete--product-matches__imageWrap",
	"image": "findify-components-autocomplete--product-matches__image",
	"content": "findify-components-autocomplete--product-matches__content",
	"price-wrapper": "findify-components-autocomplete--product-matches__price-wrapper",
	"priceWrapper": "findify-components-autocomplete--product-matches__price-wrapper",
	"grid-column-class": "findify-components-autocomplete--product-matches__grid-column-class",
	"gridColumnClass": "findify-components-autocomplete--product-matches__grid-column-class",
	"view-more-button": "findify-components-autocomplete--product-matches__view-more-button",
	"viewMoreButton": "findify-components-autocomplete--product-matches__view-more-button"
};